import { Link } from "react-router-dom";
import { articles } from "../../../mocks/gossip";
import { StackCard } from "../../../components/feature/ArticleCard";

const IDS = ["gua-003", "gua-005", "gua-004"];
export default function FeatureSection() {
  const picks = articles.filter((a) => IDS.includes(a.id));
  const big = picks[0];
  const rest = picks.slice(1);

  return (
    <section id="feature" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-8 py-10 md:py-14">
        <div className="flex items-end justify-between mb-7">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 text-secondary-900 px-3 py-1 text-xs font-medium mb-3">
              <i className="ri-book-open-fill" aria-hidden="true"></i> 深读
            </span>
            <h2 className="font-heading font-bold text-foreground-950 text-xl md:text-2xl">深扒 · 长文专题</h2>
            <p className="text-foreground-500 text-sm mt-1.5">不只看热闹，更把事情的来龙去脉给你讲透</p>
          </div>
          <Link to="/#feed" className="hidden md:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap">
            返回最新 <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          <Link
            to={`/article/${big.id}`}
            className="group lg:row-span-2 lg:col-span-1 relative rounded-2xl overflow-hidden block min-h-[420px] bg-background-200"
          >
            <div className="relative h-full min-h-[420px] w-full">
              <img src={big.cover} alt={big.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition duration-700" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/25 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                <span className="inline-flex items-center gap-1 rounded-md bg-accent-500 text-background-50 px-2.5 py-1 text-xs font-bold mb-3">
                  <i className="ri-star-fill text-sm" aria-hidden="true"></i> 编辑推荐
                </span>
                <h3 className="font-heading font-bold text-background-50 text-lg md:text-xl leading-snug line-clamp-3 group-hover:text-accent-300 transition">{big.title}</h3>
                <p className="mt-3 text-sm text-background-200/85 line-clamp-2">{big.summary}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-accent-400 whitespace-nowrap">
                  阅读全文 <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </div>
            </div>
          </Link>
          {rest.map((a) => (
            <div key={a.id} className="lg:col-span-1">
              <StackCard article={a} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}